export const blockIconsAndroidWifiTetheringNew = (
	<span className='material-symbols-outlined'>wifi_tethering</span>
);
